import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterOutlet } from '@angular/router';
import { NgClass } from '@angular/common';
import { BottomNavbarComponent, HomeNavbarComponent, PageLayoutComponent } from '@ui-components';
import { AppRoutes, AUTH_CLIENT_TOKEN, AuthClientProvider, CreateActionModalService, FindGamesRoutes } from '@core';
import { filter, switchMap } from 'rxjs';
import { NotificationsListQueryHandler } from '@notifications';

@Component({
  selector: 'lib-find-games-home',
  templateUrl: './find-games-home.component.html',
  styleUrls: ['./find-games-home.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [RouterOutlet, HomeNavbarComponent, BottomNavbarComponent, NgClass, PageLayoutComponent],
  providers: [NotificationsListQueryHandler, CreateActionModalService]
})
export class FindGamesHomeComponent {
  private readonly router: Router = inject(Router);
  private readonly createActionModalService: CreateActionModalService = inject(CreateActionModalService);
  private readonly notificationsListQueryHandler: NotificationsListQueryHandler = inject(NotificationsListQueryHandler);
  private readonly authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);

  readonly isNewNotifications: Signal<boolean | undefined> = toSignal(
    this.authClientProvider.isAuthed$.pipe(
      filter((isAuthed: boolean) => isAuthed),
      switchMap(() => this.notificationsListQueryHandler.hasUnreadNotifications())
    )
  );

  get isMapActive(): boolean {
    return this.router.url.includes(FindGamesRoutes.MAP);
  }

  goToGameCreator(): void {
    this.createActionModalService.open();
  }

  goToList(): void {
    this.router.navigateByUrl(AppRoutes.FIND_GAMES);
  }

  goToMap(): void {
    this.router.navigateByUrl(`${AppRoutes.FIND_GAMES}/${FindGamesRoutes.MAP}`);
  }
}
